/**
 * @internal
 * Node attribute used to identify if the content is from Google Sheets.
 */
export const GOOGLE_SHEET_NODE_NAME = 'google-sheets-html-origin';
/**
 * @internal
 * Name of the HTMLMeta Property that provides the Office App Source of the pasted content
 */
export const PROG_ID_NAME = 'ProgId';
/**
 * @internal
 * Name of the HTMLMeta Property that identifies pated content as from Excel Desktop
 */
export const EXCEL_DESKTOP_ATTRIBUTE_NAME = 'xmlns:x';
